import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ProductFilter from "./StoreComponents/ProductFilter";
import "./Store.css";
import Product from "./StoreComponents/Product";
import Spinner from "../Spinner/Spinner";
import axios from "axios";
import AOS from "aos";
import topImg from "../../../assets/img/topImage.png";
import topImgMobile from "../../../assets/img/topImageMobile2.png";

class Store extends Component {
  state = {
    count: 0,
    selectedProduct: "all",
    productList: [],
    curProducts: [],
    isFull: false,
    loading: false,
  };

  getProductsFromServer = () => {
    this.setState({
      loading: true,
    });
    axios
      .get("https://server.codeium.tech/product", {
        params: {
          count: this.state.count,
        },
      })
      .then((response) => {
        if (Array.isArray(response.data.msg)) {
          this.setState((prevState) => ({
            productList: prevState.productList.concat(response.data.msg),
          }));
        } else {
          this.setState({
            isFull: true,
          });
        }
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        // console.log(err);
        this.setState({
          loading: false,
          isEmpty: true,
        });
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    let currLocation = this.props.location.pathname;
    if (currLocation === "/store") {
      this.getProductsFromServer();
    } else {
      this.getCategoryProducts();
    }
    this.aos = AOS;
    this.aos.init({ duration: 1000, once: true });
  }

  componentDidUpdate(prevProps, prevState) {
    this.aos.refresh();
    let currLocation = this.props.location.pathname;
    if (prevProps.location.pathname !== currLocation) {
      this.setState({
        count: 0,
        productList: [],
      });
      if (currLocation === "/store") {
        this.getProductsFromServer();
      } else {
        if (prevState.count === 0) {
          this.getCategoryProducts();
        }
      }
    }

    if (prevState.count !== this.state.count) {
      if (currLocation === "/store") {
        this.getProductsFromServer();
      } else {
        this.getCategoryProducts();
      }
    }
  }

  getCategoryProducts = () => {
    let currLocation = this.props.location.pathname;
    this.setState({
      loading: true,
    });
    const category = currLocation.slice(16);
    axios
      .get("https://server.codeium.tech/products/" + category, {
        params: {
          count: this.state.count,
        },
      })
      .then((response) => {
        if (Array.isArray(response.data.msg)) {
          this.setState((prevState) => ({
            productList: prevState.productList.concat(response.data.msg),
          }));
        } else {
          this.setState({ isFull: true });
        }
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        // console.log(err);
        this.setState({
          loading: false,
        });
      });
    // console.log(this.state.count);
  };

  increaseProductCount = () => {
    this.setState((prevState) => ({
      count: prevState.count + 12,
    }));
  };

  render() {
    let imgSrc = topImg;
    if (window.innerWidth <= 532) {
      imgSrc = topImgMobile;
    }
    return (
      <div className="Store">
        <div data-aos="zoom-out" className="TopImgContainer">
          <img src={imgSrc} />
        </div>
        <div className="ProductsHeader mb-4">
          <ul>
            <li className="active">
              <a href="">PRODUCTS</a>
            </li>
          </ul>
        </div>

        <div className="ProductsContainer">
          <div className="row m-0">
            <div className="col-md-2 ProdFilterCol">
              <ProductFilter
                clicked={this.selectProduct}
                selectedProduct={this.state.selectedProduct}
              />
            </div>

            <div className="col-md-10 col-sm-12 ProductList">
              {this.state.loading ? (
                <Spinner />
              ) : (
                this.state.productList.map((product) => {
                  return <Product key={product.product_id} product={product} />;
                })
              )}

              {this.state.isEmpty ? (
                <h5 className="mx-auto">
                  Sorry! Currently we are not receiving any orders.
                </h5>
              ) : !this.state.isFull ? (
                <div className="MoreProductContainer">
                  <button
                    onClick={this.increaseProductCount}
                    className="MoreProducts"
                  >
                    More Products
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Store);
